<template>
  <div id="app">
    <HeaderView />
    <router-view />
    <FooterView />
  </div>
</template>
<script>
import HeaderView from "@/components/HeaderView.vue";
import FooterView from "@/components/FooterView.vue";
export default {
  name: "header-view",
  components: {
    HeaderView,
    FooterView,
  },
  mounted() {
    if (this.$route.query.code) {
      window.code = this.$route.query.code;
    }
    this.setStats();
  },
  methods: {
    setStats() {
      const scriptElement = document.createElement("script");
      scriptElement.async = true;
      scriptElement.defer = true;
      scriptElement.src = "https://eu.umami.is/script.js";
      scriptElement.dataset.websiteId = '69d0a7a0-8621-4c2e-b1ee-6a376c1d821e';
      scriptElement.dataset.doNotTrack = "true";
      scriptElement.dataset.autoTrack = "true";
      document.body.append(scriptElement);
    },
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    currentPath() {
      return this.$route.path;
    },
  },
};
</script>
